import { render } from "./StandardSection.vue?vue&type=template&id=217d8fcc"
import script from "./StandardSection.vue?vue&type=script&lang=js"
export * from "./StandardSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/apriyadi/projects/lifetime/hitting-the-target-australia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__